// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
 // ApiUrl: 'http://imexsol.southcentralus.cloudapp.azure.com/mastarwrepsapi/',
  //  ApiUrl: 'http://216.223.185.78:7117/imx4wr/',
    //   ApiUrl: 'http://12.193.185.167:81/IMEXWRepAPI/',
  //  ApiUrl: 'http://162.253.186.171/wrepsb9a/',
   //ApiUrl: 'http://192.168.100.54/wrapi/',  //TSD LOCAL
   ApiUrl: 'http://71.78.121.236/wrapi/',  //TSD remote 
   // ApiUrl: 'http://localhost:5877/',
  Core: {
    TransportMode: "TransportMode",
    WhsePrinterType: "WhsePrinterType",
    CarrierMode: "CarrierMode",
    WhseOrderType: "WhseOrderType",
    WRecStatus: "WRecStatus",
    PickType: "PickType",
    PickStatus: "PickStatus",
    WarehouseLocationType: "WarehouseLocationType",
    WarehouseType: "WarehouseType",
    OneKeyType: "OneKeyType"
}
};
